import React from "react";
import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

// import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import Home from "./Pages/Home";
import Menu from "./Pages/Menu";
import Gallery from "./Pages/Gallery";
import ContactUs from "./Pages/ContactUs";
import AboutUs from "./Pages/AboutUs";
import Login from "./Pages/Login";
import Cart from "./Pages/Cart";
import MyOrder from "./Pages/MyOrder";
import NotFound from "./Pages/NotFound";

import Register from "./Pages/Register";
import OtpVerify from "./Pages/OtpVerify";
import MyAccount from "./Pages/MyAccount";
import TermsAndConditions from "./Pages/TermsAndConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import ThankYou from "./Pages/ThankYou";
import BlogDetail from "./Blog/BlogDetail";
import Blog from "./Blog/Blog";
import OrderNowSticky from "./components/OrderNowSticky";
import AussieBreakfast from "./categories/AussieBreakfast";
import IndianStreetFood from "./categories/IndianStreetFood";
import IndoChinese from "./categories/IndoChinese";
import IndianCuisine from "./categories/IndianCuisine";
import Offers from "./Pages/Offers";
import ScrollToTop from "./components/ScrollToTop";
import PaymentPage from "./Pages/PaymentPage";
// import ApplePayButton from "./Pages/ApplePayButton";
import SquareApplePayOnly from "./Payment/SquareApplePayOnly";
const Main = () => {
  return (
    <>
     
      <Header />
      <ScrollToTop/>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/view-our-menu" element={<Menu />} />
        <Route path="/about-mandurah-cafe" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/otp-verify" element={<OtpVerify />} />

        {/* Protected Routes */}
        <Route path="/my-cart" element={<Cart />} />
        <Route path="/my-order" element={<MyOrder />} />

        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/teams-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/thank-you" element={<ThankYou />} />

        <Route path="/informative-blog" element={<Blog />} />
        <Route path="/informative-blog/:slug" element={<BlogDetail />} />

        <Route path="/aussie-breakfast-in-mandurah" element={<AussieBreakfast />} />
        <Route path="/indian-street-food-in-mandurah" element={<IndianStreetFood />} />
        <Route path="/indo-chinese-in-mandurah" element={<IndoChinese />} />
        <Route path="/indian-cuisine-in-mandurah" element={<IndianCuisine />} />

         <Route path="/mandurah-cafe-offers" element={<Offers />} />
          <Route path="/create-payment-and-order" element={<PaymentPage />} />
          <Route path="/payment" element={<SquareApplePayOnly  />} />

      

        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <OrderNowSticky />
      <Footer />
     
    </>
  );
};

export default Main;
